<div dir="ltr">

    <div class="m-2 d-inline-block ppp-input-number">
        <p-inputNumber
        [(ngModel)]="limit"
        [min]="5"
        (ngModelChange)="onLimitChange()"
        [inputStyle]="{'text-align': 'right'}"
        [step]="10"
        [showButtons]="true" buttonLayout="horizontal"
        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
        ></p-inputNumber>
        <label class="m-2 ms-label-view">{{"Limit" | translator }}</label>
    </div>


    <div class="m-2 d-inline-block ppp-calander">

        <p-calendar class="ppp-calander"
        [(ngModel)]="endDate"
        [dateFormat]="'dd MM yy'"
        [minDate]="startDate"
        [maxDate]="today"
        (ngModelChange)="onDateChange()"
        [showIcon]="true"
        [showButtonBar]="true"
        [inputStyle]="{'text-align': 'right'}"
        >
        </p-calendar>
        <label  class="m-2 ms-label-view">{{"End Date" | translator }}</label>

    </div>


    <div class="m-2 d-inline-block ppp-calander">

        <p-calendar
        [(ngModel)]="startDate"
        [dateFormat]="'dd MM yy'"
        [maxDate]="endDate"
        (ngModelChange)="onDateChange()"
        [showIcon]="true"
        [showButtonBar]="true"
        [inputStyle]="{'text-align': 'right'}">
        </p-calendar>
        <label class="m-2 ms-label-view">{{"Start Date" | translator }}</label>

    </div>



</div>
<div class="v4-graph-bg">
<p-chart type="line" [data]="chartData" [options]="chartOptions"  height="400"></p-chart>
</div>